import { useContext, useEffect, useRef, useState } from 'react';
import Bookmark from '../../../../../../Assets/Lens/SaveIcon.svg';
import BookmarkGreen from '../../../../../../Assets/Lens/BookmarkGreen.svg';
import PlayGray from '../../../../../../Assets/Lens/PlayGray.svg';
import PauseGreen from '../../../../../../Assets/Lens/PauseGreen.svg';
// import PlayWhite from '../../../../../../Assets/Lens/PlayWhite.svg';
import PauseWhite from '../../../../../../Assets/Lens/PauseWhite.svg';
import { VideoContext } from '../../../../../../Context/VideoContext';
import { formatDuration } from '../../../../../../lib/utils/utils';
import { addMusicToSaved, checkSongSavedStatus, removeMusicFromSaved } from '../../../../../../lib/utils/apiCalls';
import { MoonLoader } from 'react-spinners';
import { showToast } from '../../../../../../Components/Toaster/Toaster';

function Audio({ audio, musicUrl, selected, handleLocalAudioSelect }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const [audioAvailable, setAudioAvailable] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const {
        trackID,
        setTrackID,
        handleSavedAudioRequest,
    } = useContext(VideoContext);

    const playAudio = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setTrackID(audio.trackId);
        audioRef.current.play();
        setIsPlaying(true);
    }

    const pauseAudio = (e) => {
        e.preventDefault();
        e.stopPropagation();

        audioRef.current.pause();
        setTrackID('');
        setIsPlaying(false);
    }

    const getSongSavedStatus = async (trackId) => {
        try {
            const response = await checkSongSavedStatus(trackId);
            setIsSaved(response);
        }
        catch(err) {
            console.error(err);
        }
    }

    const handleBookmarkClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if(isSaved) {
            try {
                await removeMusicFromSaved(audio.trackId);
                getSongSavedStatus(audio.trackId);
                handleSavedAudioRequest();
                showToast('Music removed from saved list!', 'success');
            }
            catch(err) {
                console.error(err);
            }
        }
        else {
            try {
                await addMusicToSaved(audio.trackId);
                getSongSavedStatus(audio.trackId);
                handleSavedAudioRequest();
                showToast('Music added to saved list!', 'success');
            }
            catch(err) {
                console.error(err);
            }
        }
    }

    const handleAudioClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if(selected.trackId === audio.trackId) {
            handleLocalAudioSelect({});
        }
        else {
            handleLocalAudioSelect(audio);
        }
    }

    useEffect(() => {
        if (trackID && audioRef.current) {
            if(trackID !== audio.trackId) {
                audioRef.current.pause();
                setIsPlaying(false);
            }
            else {
                audioRef.current.play();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trackID]);

    useEffect(() => {
        if(audio.trackId) {
            getSongSavedStatus(audio.trackId);
        }
    }, [audio])

    const handleCanPlay = () => {
        setAudioAvailable(true);
    }

    return (
        <div className='flex flex-col'>
            <div onClick={handleAudioClick} className={`w-full cursor-pointer flex items-center gap-3 p-2 ${selected.trackId === audio.trackId ? 'bg-primaryColor' : 'bg-[#FFFFFF] hover:bg-[#E5E7EB]'}`}>
                <div className="w-[calc(100%-44px)] flex items-center gap-3">
                    <div className="size-[60px] rounded overflow-hidden">
                        <img className='size-full object-cover' src={audio.thumbnail['150x150']} alt="" />
                    </div>

                    <div className="w-[calc(100%-72px)] flex items-center">
                        <div className="w-[calc(100%-24px)] flex flex-col gap-1">
                            <h1 className={`font-medium text-[16px] leading-[19.2px] ${selected.trackId === audio.trackId ? 'text-buttonText' : 'text-[#212121]'} overflow-hidden whitespace-nowrap text-ellipsis`}>{audio.name}</h1>

                            <p className={`font-normal text-[12px] leading-[14.4px] ${selected.trackId === audio.trackId ? 'text-buttonText' : 'text-[#808080]'}`}>{audio.genre}</p>

                            {
                                audioAvailable ? 
                                <p className={`font-normal text-[12px] leading-[14.4px] ${selected.trackId === audio.trackId ? 'text-buttonText' : 'text-[#808080]'}`}>Duration : {formatDuration(audioRef.current.duration)}</p> : 
                                <div className="w-4 h-[14.4px]"></div>
                            }
                        </div>

                        <div className="size-6 flex items-center justify-center">
                            <button onClick={handleBookmarkClick}>
                                <img src={isSaved ? BookmarkGreen : Bookmark} alt="" />
                            </button>
                        </div>
                    </div>
                </div>

                {
                    audioAvailable ? 
                    <div className="size-8 flex items-center justify-center">
                        {
                            isPlaying ? 
                            <button onClick={pauseAudio}>
                                <img src={isPlaying && (selected.trackId === audio.trackId) ? PauseWhite : PauseGreen} alt="" />
                            </button> :
                            <button onClick={playAudio}>
                                <img src={PlayGray} alt="" />
                            </button>
                        }
                    </div> : 
                    <div className="size-8 flex items-center justify-center">
                        <MoonLoader size={24} color="#36d7b7" />
                    </div>
                }
            </div>

            <audio 
                className='hidden' 
                controls
                ref={audioRef} 
                src={musicUrl} 
                onCanPlay={handleCanPlay}
            ></audio>
        </div>
    );
}

export default Audio;
